import { List, ListItem } from "@astryxdesign/core/List";
import { Text } from "@astryxdesign/core/Text";
import { Icon } from "@astryxdesign/core/Icon";
import { HStack } from "@astryxdesign/core/Stack";
import type { Service, Studio } from "@/lib/api/schemas";
import { formatDuration, formatPrice } from "@/lib/format";
import { mediaUrl } from "@/lib/env";
import { serviceImagePath } from "@/lib/media";

/** Dense service rows: name, duration, price; tap opens the booking sheet. */
export function ServiceList({ studio, services, onPick, header }: { studio: Studio; services: Service[]; onPick: (s: Service) => void; header?: string }) {
  return (
    <List hasDividers density="balanced" header={header ? <Text type="label" color="secondary">{header}</Text> : undefined}>
      {services.map((s) => {
        const img = mediaUrl(serviceImagePath(studio, s));
        return (
          <ListItem
            key={s.id}
            label={s.name}
            description={
              <HStack gap={2} wrap="wrap">
                <Text type="supporting">{formatDuration(s.duration_minutes)}</Text>
                <Text type="supporting">·</Text>
                <Text type="supporting" color="accent">
                  {formatPrice(s, studio.currency)}
                </Text>
              </HStack>
            }
            startContent={img ? <img src={img} alt="" width={56} height={56} loading="lazy" className="size-14 rounded-lg object-cover" /> : undefined}
            endContent={<Icon icon="chevronRight" color="secondary" />}
            onClick={() => onPick(s)}
          />
        );
      })}
    </List>
  );
}
